import { BasicPoint, PointGroupOptions } from 'signature_pad';

export interface CipoSignature {
  id: number;
  fontSize: number;
  signature: string;
  signatureText: string;
  type: SignatureType;
}

export enum SignatureType {
  Draw = 1,
  Text = 2,
  Image = 3,
}

export const DEFAULT_SIGNATURE_OPTIONS: PointGroupOptions = {
  velocityFilterWeight: 0.7,
  dotSize: 0,
  minWidth: 0.5,
  maxWidth: 2.5,
  penColor: 'rgb(0, 0, 0)',
  compositeOperation: 'source-over',
};

export const DEFAULT_SIGNATURE_POINT: BasicPoint = {
  x: 0,
  y: 0,
  time: 0,
  pressure: 0.5,
};
